import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthStatusManager {
  private static instance: AuthStatusManager;
  private static authStatusSubject = new BehaviorSubject<boolean>(false);
  private static isInitialized = false;

  public static getInstance(): AuthStatusManager {
    if (!AuthStatusManager.instance) {
      AuthStatusManager.instance = new AuthStatusManager();
    }
    return AuthStatusManager.instance;
  }

  public static getAuthStatus$() {
    return AuthStatusManager.authStatusSubject.asObservable();
  }

  public static getCurrentAuthStatus(): boolean {
    return AuthStatusManager.authStatusSubject.value;
  }

  public static setAuthStatus(isAuthenticated: boolean): void {
    if (AuthStatusManager.authStatusSubject.value !== isAuthenticated) {
      AuthStatusManager.authStatusSubject.next(isAuthenticated);
    }
  }

  public static clearAuthStatus(): void {
    AuthStatusManager.authStatusSubject.next(false);
    AuthStatusManager.isInitialized = false;
  }

  public static markAsInitialized(): void {
    AuthStatusManager.isInitialized = true;
  }

  public static isAlreadyInitialized(): boolean {
    return AuthStatusManager.isInitialized;
  }
}
